
















import { Vue, Component, Prop } from "vue-property-decorator";
import DetailsInfo from "../Details/DetailsInfo.vue";
import { bus } from "../../main"; 

@Component({
  components: {
    DetailsInfo
  }
})
export default class DetailsDialog extends Vue {
  @Prop() params!: string;
  @Prop() info!: object;
  private dialog: boolean;

  constructor() {
    super();
    this.dialog = false;
  }

  close() {
    this.dialog = false;
    bus.$emit("destroyDetailDialog");
  }

  created() {
    bus.$on("closeDetailsDialog", () => {
      this.close();
    });
  }

  // created(){
  //   console.log(this.info)
  //   console.log(this.params)
  // }
}
